import axios, { AxiosResponse } from 'axios';
import { environment } from '@env/environment';
import { GetKeysResponse } from '@app/core/models/api-key';

export const client = axios.create({
  baseURL: environment.apiKeyAdminURLBase,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false,
  responseType: 'json',
});

export const ApiKeyService = {
  async getKeys(clientId: string): Promise<GetKeysResponse> {
    try {
      const response: AxiosResponse<GetKeysResponse> = await client.get(
        `client/${clientId}/apikey`,
      );
      return response.data;
    } catch (error) {
      throw new Error('Could not fetch API keys.');
    }
  },
};
